import { useMemo } from 'react';

import Typography from '@mui/material/Typography';
import Countdown, { CountdownRenderProps } from 'react-countdown';

/** Live countdown of the remaining seconds before a quiz's minimum time is met. */
export default function QuizMinTimeCountdown({ secondsRemaining }: { secondsRemaining: number }) {
  const targetDate = useMemo(() => Date.now() + secondsRemaining * 1000, [secondsRemaining]);
  return (
    <Countdown
      date={targetDate}
      renderer={({ hours, minutes, seconds }: CountdownRenderProps) => {
        const minutesLabel = hours > 0 ? (hours * 60 + minutes).toString() : minutes.toString();
        return (
          <Typography color="text.secondary">
            {minutesLabel}:{seconds.toString().padStart(2, '0')} remaining before you can submit
          </Typography>
        );
      }}
    />
  );
}
